"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePrintSharedValues = void 0;
const react_1 = require("react");
const shared_values_model_1 = require("./shared-values.model");
const default_shared_store_1 = require("./default-shared-store");
function usePrintSharedValues() {
    const store = react_1.useContext(shared_values_model_1.SharedValueContext);
    return function print() {
        const values = getStoreValues(store);
        console.info(values);
    };
}
exports.usePrintSharedValues = usePrintSharedValues;
function getStoreValues(store) {
    const values = {};
    for (const key of store.allKeys()) {
        values[key] = getStoreValue(key, store);
    }
    return values;
}
function getStoreValue(key, store) {
    const value = store.getValue(key);
    return isStore(value) ? getStoreValues(value) : value;
}
function isStore(value) {
    return value instanceof default_shared_store_1.DefaultSharedStore;
}
//# sourceMappingURL=print-shared-values.js.map